import React from "react";
import { useHistory } from "react-router-dom";
import { Button, ListButton } from "react-admin";
import { ChevronLeftIcon } from "./iconography";
import { parsePath } from "history";

export const BackButton = ({ basePath, backPath, state, search, ...props }) => {
  const history = useHistory();

  const handleRedirect = () => {
    // history.goBack(); can't use it - will bring you back to child item that was saved rather back to parent / list
    const returnPath = backPath.pop();
    history.push({
      ...parsePath(returnPath),
      state: {
        ...state,
        backPath: backPath,
      },
    });
  };

  return backPath?.length > 0 ? (
    <Button label="Back" onClick={handleRedirect}>
      <ChevronLeftIcon />
    </Button>
  ) : (
    <ListButton label="Back" basePath={basePath} icon={<ChevronLeftIcon />} />
  );
};
